import { useMutation } from "@tanstack/react-query";
import type { BulkReviewPayload } from "@unbox/api";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client, useScopedMerchantClient } from "../scoped-merchant-client";

export const useBulkReviewVideos = () => {
  const scope = useScopedMerchantClient();

  return useMutation({
    mutationFn: async (payload: BulkReviewPayload) => {
      if (!scope.merchantId) throw new Error("No merchant selected");

      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].assurance.review.bulk.$post({
            param: scope.param,
            json: payload,
          })
        : await client.merchant[":merchantId"].assurance.review.bulk.$post({
            param: scope.param,
            json: payload,
          });

      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: () => {
      if (!scope.merchantId) return;
      queryClient.invalidateQueries({ queryKey: ["assurance-video", scope.merchantId, scope.workspaceId] });
      queryClient.invalidateQueries({ queryKey: ["video", scope.merchantId, scope.workspaceId] });
    },
  });
};
